module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "galley"
  }, [_c('div', {
    staticClass: "frontmatter Other exclude-auto page-open-auto",
    attrs: {
      "id": "Other2"
    }
  }, [_c('p', {
    attrs: {
      "id": "p85"
    }
  }, [_c('a', {
    attrs: {
      "id": "pagebreak-rw_2"
    }
  })]), _c('a', {
    attrs: {
      "id": "pagebreak-rw_2"
    }
  }, [_c('div', {
    staticClass: "media image float-none floatgalley-none align-center width-auto exclude-auto",
    attrs: {
      "id": "image2"
    }
  }, [_c('div', {
    staticClass: "pc",
    attrs: {
      "id": "pc2"
    }
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "a002_online.jpg"
    }
  })])])])]), _c('a', {
    attrs: {
      "id": "pagebreak-rw_2"
    }
  })]), _c('a', {
    attrs: {
      "id": "pagebreak-rw_2"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-173c03ae","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9781783784370_other_02.vue
// module id = 78
// module chunks = 0